var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
const IP_ASSISTANT_SETTINGS_PATH = '/ip_assistant';
const ALLOWED_USERS_PATH = '/ip_assistant/allowed_users';
const USERS_SEARCH_PATH = '/api/internal/ip_assistant_users';
const UPDATE_ERROR_MESSAGE = 'Unable to update Inspect Point Assistant setting.';
export const DEFAULT_PER_PAGE = 10;
export function getSettings() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(IP_ASSISTANT_SETTINGS_PATH, {
            headers: { Accept: 'application/json' }
        });
        return response.data;
    });
}
export function updateSettings(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        try {
            yield api.put(IP_ASSISTANT_SETTINGS_PATH, { tenant: payload }, { headers: { Accept: 'application/json' } });
        }
        catch (error) {
            const axiosError = error;
            const errorMessage = (_b = (_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors;
            if (typeof errorMessage === 'string' && errorMessage.length > 0) {
                throw new Error(errorMessage);
            }
            if (error instanceof Error) {
                throw error;
            }
            throw new Error(UPDATE_ERROR_MESSAGE);
        }
    });
}
function buildSortParams(params, sort) {
    if (sort && sort.sortBy && sort.sortDirection) {
        params.sort_by = sort.sortBy;
        params.sort_direction = sort.sortDirection;
    }
}
export function getAllowedUsers(page, perPage, sort) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = { page, per_page: perPage };
        buildSortParams(params, sort);
        const response = yield api.get(ALLOWED_USERS_PATH, { params });
        return response.data;
    });
}
export function searchUsers(query, page, perPage, sort) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = { page, per_page: perPage };
        if (query) {
            params.search = query;
        }
        buildSortParams(params, sort);
        const response = yield api.get(USERS_SEARCH_PATH, { params });
        return response.data;
    });
}
